import { getPath, getInitialState } from "../../utils";

const initialState = {
  settlementProcessesList: [],
  activeSettlementProcessesFilters: {},
  prevPage: -1,
  nextPage: -1,
  currentPage: 1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES":
      return setDriverAccountingSettlementProcesses(state, action);
    case "SET_ACTIVE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES_FILTERS":
      return setActiveFiltersSettlementProcesses(state, action);
    case "RESET_STATE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES":
      return resetState(state, action);
    case "SET_CURRENT_PAGE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESS":
      return setCurrentpageSettlementProcess(state, action);
    default:
      return state;
  }
}

const setCurrentpageSettlementProcess = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setDriverAccountingSettlementProcesses = (state, action) => {
  return {
    ...state,
    settlementProcessesList: getPath(action.payload, "data", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const setActiveFiltersSettlementProcesses = (state, action) => {
  return {
    ...state,
    activeSettlementProcessesFilters: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
